import $ from 'jquery'
import { debounce } from './utilities'

function footer() {
	// Set footer height as CSS variable

	let footer = document.querySelector('.c-connect-bar');

	setFooterHeightVar()	
	window.addEventListener('resize', debounce(setFooterHeightVar))

	function setFooterHeightVar() {
		const height     = document.documentElement.style.getPropertyValue('--footer-height'),
					calcHeight = `${footer.offsetHeight}px`;
		
		if( height !== calcHeight ) {		
			document.documentElement.style.setProperty('--footer-height', calcHeight)
		}
	}
}

export { footer }